import { Routes ,Route } from 'react-router-dom';
import Footer from './components/Footer';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Contact from './pages/Contact';
import About from './pages/About';
import Learn from './pages/Learn/Learn';
import GuideNFT from './pages/Learn/GuideNFT';
import Glosario from './pages/Learn/Glosario';
import Seguridad from './pages/Learn/Seguridad';
import Carteras from './pages/Learn/Carteras';
import ComprarNFT from './pages/Learn/ComprarNFT';
import Discord from './pages/Learn/Discord';
import Wallets from './pages/Learn/Wallets';
import Blog from './pages/Blog';
import Somos from './pages/Blog/Somos';
import Mint from './pages/Mint/Mint';
import Action from './components/Action';


function App() {

  return (
    <div className="App">
      <div>
      <header className="bg-white z-50">
        <Navbar />
        <Action />
      </header>
      <Routes>
       <Route index element={<Home/>} />
       <Route path='/learn' element={<Learn />} />
       <Route path='/guidenft' element={<GuideNFT />} />
       <Route path='/glosario' element={<Glosario />} />
       <Route path='/seguridad' element={<Seguridad />} />
       <Route path='/carteras' element={<Carteras />} />
       <Route path='/wallets' element={<Wallets />} />
       <Route path='/comprarnft' element={<ComprarNFT />} />
       <Route path='/discord' element={<Discord />} />
       <Route path='/contact' element={<Contact />} />
       <Route path='/about' element={<About />} />
       <Route path='/blog' element={<Blog />} />
       <Route path='/somos' element={<Somos />} />
       <Route path='/mint' element={<Mint />} />
      </Routes>    
      </div>
      <footer className="bg-gray-50" aria-labelledby="footer-heading">
        <Footer />
      </footer>
    </div>
  );
}

export default App;